import React, { Fragment } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Filters } from './components'
import { Filtered, Unfiltered } from './scenes'
import { getAllInterests } from '../../actions/interests'
import { EventBar, Slider } from '../../components';

const Banner = ({ title, subtitle, image }) => {

	image = image ? image : 'https://admin.startup-club.co.uk/wp-content/uploads/2016/10/fundraising-1024x559.jpg';
	subtitle = subtitle ? subtitle : 'Here\'s the best advice from our Startup Club community';

	return(
		<div className="banner" style={{
			backgroundImage: `url(${image})`,
		}}>
			<div className="banner__content">
				<h1>{ title }</h1>
				<p>{ subtitle }</p>
			</div>
		</div>
    );
}

class Discover extends React.Component {
	
    componentDidMount() {
    	if(!this.props.interests || !this.props.interests.length) {
			this.props.getAllInterests()
		}
	}

    render() {
		const { slug } = this.props.match.params;

		let interest = slug && this.props.interests ? this.props.interests.find(i => i.slug === slug) : null;

		return (
			<Fragment>

				{ !slug ? (
					<Fragment>
						<Slider />
						<EventBar />
					</Fragment>
				) : (
					<Banner
						title={interest ? interest.banner ? interest.banner.title : interest.title : null}
						subtitle={interest && interest.banner ? interest.banner.subtitle : null}
						image={interest && interest.banner ? interest.banner.image.sizes.large : null}
					/>
				) }


				<div className="container pbot40">

					<Filters filteredSlug={slug} />

					{ !!slug ? <Filtered slug={slug} /> : <Unfiltered /> }

				</div>
			</Fragment>
		)
		
	}
}

const mapStateToProps = state => ({
	interests: state.interests.all
});

const mapDispatchToProps = dispatch => bindActionCreators({ getAllInterests }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Discover );




// WEBPACK FOOTER //
// ./src/js/views/Discover/index.jsx